export default __webpack_public_path__ + "s13.png";